export const LevelToIcon: Record<string, string> = {
  info: 'circle-information',
  neutral: 'circle-information',
  warn: 'triangle-exclamation',
  error: 'circle-exclamation',
  success: 'circle-checkmark',
}
